import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FiHome,
  FiFileText,
  FiPlusCircle,
  FiBarChart2,
  FiChevronRight,
  FiMenu,
  FiX,
  FiSettings,      // ✅ ADD THIS
  FiDatabase,      // ✅ ADD THIS
  FiClock,         // ✅ ADD THIS
} from "react-icons/fi";
import { MdRecordVoiceOver } from "react-icons/md";
import "../Sidebar/Sidebar.css";
import axios from "axios";

const Sidebar = ({
  userRole,
  permission = [],
  loading,
  error,
  isOpen = true,
  toggleSidebar,
  onMouseEnter,
  onMouseLeave,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeMenu, setActiveMenu] = useState("");
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [activeSubmenuItem, setActiveSubmenuItem] = useState("");

  // Responsive state
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [adminCategories, setAdminCategories] = useState([]);

  // Handle responsive layout
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);
      if (!mobile) {
        setMobileSidebarOpen(false); // Close mobile sidebar on desktop
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const permissions = useMemo(
    () => new Set(permission),
    [permission]
  );

  const iconMap = {
    "assessment controls": <FiSettings />,
    "ai configuration": <FiDatabase />,
    "question management": <FiFileText />,
    "scheduling rules": <FiClock />,
    "report analytics": <FiBarChart2 />,
  };

  const getIcon = (name) => iconMap[name?.trim().toLowerCase()] || <FiSettings />;

  useEffect(() => {
    const fetchAdminConfig = async () => {
      try {
        const res = await axios.get(
          "/config/admin-config/?plant_guid=87921d04-9715-402b-8d82-052d331cdc24",
          {
            withCredentials: true
          }
        );

        

        const categories = Object.keys(res.data.data || {});
        console.log(categories, "ssssssssssssssssssssssssssss")

        const formatted = categories.map((cat) => ({
          id: cat.toLowerCase().replace(/\s+/g, "-"),
          name: cat,
          route: `/admin/${cat.toLowerCase().replace(/\s+/g, "-")}`,
          icon: getIcon(cat),
        }));

        setAdminCategories(formatted);
        console.log("ccccccccc", formatted);
      } catch (err) {
        console.error("Error fetching admin config", err);
      }
    };

    fetchAdminConfig();
  }, []);
  // Build menu
  const menuItems = useMemo(() => {
    if (loading || error) return [];

    const items = [];

    // Dashboard group (IDs 5,6,7)
    const dashboardSubs = [];

    if (permissions.has(8)) {
      dashboardSubs.push({
        name: "Manager Dashboard",
        route: "/managers/dashboard",
        icon: <FiBarChart2 />,
        flag: 8,
      });
    }

    if (permissions.has(4)) {
      dashboardSubs.push({
        name: "Coordinator Dashboard",
        route: "/hr/dashboard",
        icon: <FiBarChart2 />,
        flag: 9,
      });
    }

    if (permissions.has(9)) {
      dashboardSubs.push({
        name: "User Dashboard",
        route: "/users/dashboard",
        icon: <FiHome />,
      });
    }

    if (dashboardSubs.length > 0) {
      items.push({
        name: "Dashboard",
        icon: <FiBarChart2 />,
        submenu: dashboardSubs,
      });
    }

    if (permissions.has(11) && adminCategories.length > 0) {
      items.push({
        name: "Admin",
        icon: <FiSettings />,
        submenu: adminCategories,
      });
    }

    // ID 1 ── Exam Configuration
    if (permissions.has(5) || permissions.has(6)) {
      items.push({
        name: "Assessment Config",
        icon: <FiFileText />,
        submenu: [
          { name: "List of Assessments", route: "/managers/exams-list", icon: <FiFileText /> },
          {
            name: "Objective Assessment",
            route: "/managers/create-course/1/0",
            icon: <FiFileText />,
            examType: "objective",
          },
          {
            name: "Competency Review",
            route: "/managers/create-course/2/0",
            icon: <MdRecordVoiceOver />,
            examType: "competency",
          },
        ],
      });
    }

    // ID 2 ── Assignment Configuration
    if (permissions.has(1) || permissions.has(2)) {
      items.push({
        name: "Assignment Config",
        icon: <FiFileText />,
        submenu: [
          { name: "List of Assignments", route: "/hr/assignment-exams", icon: <FiFileText /> },
          { name: "Assign Assessment", route: "/hr/assign-course", icon: <FiPlusCircle /> },
        ],
      });
    }

    // Reports group (IDs 3,4,8)
    const reportsSubs = [];

    if (permissions.has(7)) {
      reportsSubs.push({
        name: "Manager Reports",
        route: "/report",
        icon: <FiBarChart2 />,
      });
    }

    if (permissions.has(3)) {
      reportsSubs.push({
        name: "Coordinator Reports",
        route: "/report",
        icon: <FiBarChart2 />,
      });
    }

    if (permissions.has(10)) {
      reportsSubs.push({
        name: "User Reports",
        route: "/user/reports",
        icon: <FiBarChart2 />,
      });
    }

    if (reportsSubs.length > 0) {
      items.push({
        name: "Reports",
        icon: <FiBarChart2 />,
        submenu: reportsSubs,
      });
    }

    return items;
  }, [permissions, loading, error, adminCategories]);

  // Active route detection
  useEffect(() => {
    const path = location.pathname;
    const state = location.state || {};

    setActiveMenu("");
    setActiveSubmenu(null);
    setActiveSubmenuItem("");

    menuItems.forEach((menu) => {
      if (menu.defaultRoute && path.startsWith(menu.defaultRoute)) {
        setActiveMenu(menu.name);
      }

      menu.submenu?.forEach((sub) => {
        if (sub.route && path.startsWith(sub.route)) {
          if (sub.examType && state.examType === sub.examType) {
            setActiveMenu(menu.name);
            setActiveSubmenu(menu.name);
            setActiveSubmenuItem(sub.name);
          } else if (!sub.examType) {
            setActiveMenu(menu.name);
            setActiveSubmenu(menu.name);
            setActiveSubmenuItem(sub.name);
          }
        }
      });
    });

    if (path.startsWith("/admin/")) {
      setActiveMenu("Admin");
      setActiveSubmenu("Admin");

      const matched = adminCategories.find((cat) => cat.route === path);
      if (matched) {
        setActiveSubmenuItem(matched.name);
      }
    }
  }, [location.pathname, location.state, menuItems]);

  // Handle menu click for desktop
  const handleMenuClick = (menu) => {
    setActiveMenu(menu.name);

    if (!isOpen) {
      toggleSidebar?.();
      return;
    }

    if (menu.submenu?.length > 0) {
      setActiveSubmenu((prev) => (prev === menu.name ? null : menu.name));
      return;
    }

    if (menu.defaultRoute) navigate(menu.defaultRoute);
    setActiveSubmenu(null);
    setActiveSubmenuItem("");
  };





  const handleSubmenuClick = (menuName, sub) => {
    setActiveMenu(menuName);
    setActiveSubmenu(menuName);
    setActiveSubmenuItem(sub.name);

    if (sub.examType) {
      navigate(sub.route, { state: { examType: sub.examType } });
      return;
    }

    // 👉 NEW LOGIC (replace flag usage)
    if (sub.route === "/managers/dashboard") {
      sessionStorage.setItem("user_role", "8");
    } else if (sub.route === "/hr/dashboard") {
      sessionStorage.setItem("user_role", "9");
    }

    navigate(sub.route);
  };

  // Handle menu click for mobile
  const handleMenuClickMobile = (menu) => {
    setActiveMenu(menu.name);

    if (menu.submenu?.length > 0) {
      setActiveSubmenu((prev) => (prev === menu.name ? null : menu.name));
      return;
    }

    if (menu.defaultRoute) {
      navigate(menu.defaultRoute);
      setMobileSidebarOpen(false);
    }
    setActiveSubmenu(null);
    setActiveSubmenuItem("");
  };



  const handleSubmenuClickMobile = (menuName, sub) => {
    setActiveMenu(menuName);
    setActiveSubmenu(menuName);
    setActiveSubmenuItem(sub.name);

    if (sub.examType) {
      navigate(sub.route, { state: { examType: sub.examType } });
      return;
    }

    if (sub.route === "/managers/dashboard") {
      sessionStorage.setItem("user_role", "8");
    } else if (sub.route === "/hr/dashboard") {
      sessionStorage.setItem("user_role", "9");
    }

    navigate(sub.route);
    setMobileSidebarOpen(false);
  };

  // Toggle mobile sidebar
  const toggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  // ─────────────────────────────────────────────
  // MOBILE VIEW: Show hamburger button (closed state)
  // ─────────────────────────────────────────────
  if (isMobile && !mobileSidebarOpen) {
    return (
      <button
        className="mobile-hamburger-btn"
        onClick={toggleMobileSidebar}
        aria-label="Open menu"
      >
        <FiMenu size={24} />
      </button>
    );
  }

  // ─────────────────────────────────────────────
  // MOBILE VIEW: Show mobile sidebar overlay (open state)
  // ─────────────────────────────────────────────
  if (isMobile && mobileSidebarOpen) {
    return (
      <>
        {/* Overlay */}
        <div
          className="sidebar-mobile-overlay"
          onClick={toggleMobileSidebar}
        ></div>

        {/* Mobile Sidebar */}
        <div className="sidebar-mobile-container">
          {/* Mobile Header */}
          <div className="sidebar-mobile-header">
            <div className="sidebar-mobile-logo">
              <div className="sidebar-mobile-logo-img">
                <img
                  src="/images/AudreeIcon.png"
                  alt="Logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logo-placeholder.png";
                  }}
                />
              </div>
              <h2>Skillora</h2>
            </div>

            <button
              className="sidebar-mobile-close"
              onClick={toggleMobileSidebar}
              aria-label="Close menu"
            >
              <FiX size={24} />
            </button>
          </div>

          {/* Mobile Navigation */}
          <div className="sidebar-mobile-nav">
            {menuItems.map((menu) => (
              <div key={menu.name}>
                <div
                  className={`sidebar-mobile-menu-item ${activeMenu === menu.name ? "sidebar-mobile-active" : ""
                    }`}
                  onClick={() => handleMenuClickMobile(menu)}
                >
                  <div className="sidebar-mobile-menu-icon">{menu.icon}</div>
                  <div className="sidebar-mobile-menu-content">
                    <span>{menu.name}</span>
                    {menu.submenu?.length > 0 && (
                      <FiChevronRight
                        className={`sidebar-mobile-chevron ${activeSubmenu === menu.name ? "sidebar-mobile-rotated" : ""
                          }`}
                      />
                    )}
                  </div>
                </div>

                {menu.submenu?.length > 0 && activeSubmenu === menu.name && (
                  <div className="sidebar-mobile-submenu">
                    {menu.submenu.map((sub) => (
                      <div
                        key={sub.name}
                        className={`sidebar-mobile-submenu-item ${activeSubmenuItem === sub.name ? "sidebar-mobile-active" : ""
                          }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSubmenuClickMobile(menu.name, sub);
                        }}
                      >
                        <div className="sidebar-mobile-submenu-icon">{sub.icon}</div>
                        <span className="sidebar-mobile-submenu-text">{sub.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }

  // ─────────────────────────────────────────────
  // DESKTOP VIEW: Original sidebar (unchanged)
  // ─────────────────────────────────────────────
  // if (!userRole) return null;

  if (loading) {
    return (
      <div className={`sb-container ${isOpen ? "sb-expanded" : "sb-collapsed"}`}>
        <div className="sb-header">Loading menu...</div>
      </div>
    );
  }

  if (error || menuItems.length === 0) {
    return (
      <div className={`sb-container ${isOpen ? "sb-expanded" : "sb-collapsed"}`}>
        <div className="sb-header">No menu items available</div>
      </div>
    );
  }

  return (
    <div
      className={`sb-container ${isOpen ? "sb-expanded" : "sb-collapsed"}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {/* HEADER */}
      <div className="sb-header">
        <div className="sb-logo-container">
          <div className="sb-logo">
            <img
              src="/images/AudreeIcon.png"
              alt="Logo"
              loading="eager"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/logo-placeholder.png";
              }}
            />
          </div>
          {isOpen && (
            <div className="sb-brand-info">
              <h2>Skillora</h2>
            </div>
          )}
        </div>
      </div>

      {/* NAV */}
      <div className="sb-nav">
        {menuItems.map((menu) => (
          <div key={menu.name}>
            <div
              className={`sb-menu-item ${activeMenu === menu.name ? "sb-active" : ""}`}
              onClick={() => handleMenuClick(menu)}
            >
              <div className="sb-menu-icon">{menu.icon}</div>
              {isOpen && (
                <div className="sb-menu-content">
                  <span>{menu.name}</span>
                  {menu.submenu?.length > 0 && (
                    <FiChevronRight
                      className={`sb-chevron ${activeSubmenu === menu.name ? "sb-rotated" : ""}`}
                    />
                  )}
                </div>
              )}
            </div>

            {isOpen && menu.submenu?.length > 0 && activeSubmenu === menu.name && (
              <div className="sb-submenu">
                {menu.submenu.map((sub) => (
                  <div
                    key={sub.name}
                    className={`sb-submenu-item ${activeSubmenuItem === sub.name ? "sb-active" : ""}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSubmenuClick(menu.name, sub);
                    }}
                  >
                    <div className="sb-submenu-icon">{sub.icon}</div>
                    <span className="sb-submenu-text">{sub.name}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  );
};

export default Sidebar;

